import { Container } from './styles';

import { FaWhatsapp } from 'react-icons/fa';
import { useSettings } from '../Providers/Footer';

interface IProps {
  title: string;
}

const ReusableBottomContent: React.FC<IProps> = ({ title, children }) => {
  const { settings } = useSettings();

  return (
    <Container>
      <h2>{title}</h2>
      {children}

      <a href={settings.whatsapp} target="_blank" rel="noreferrer noopener">
        Fale com um especialista <FaWhatsapp size={22} />
      </a>
    </Container>
  );
};

export default ReusableBottomContent;
